import {ReactNode, useContext} from 'react'
import classnames from 'classnames'

import {Context} from '../../../../Header/Context'
import AppButton from '../../AppButton'
import LinkButton from '../../LinkButton'
import {Text} from '../../Text'

import styles from './styles.module.css'

export type BeforeRegModalCard = {
  title: string
  icon: ReactNode
  options: string[]
  buttons: BeforeRegButton[]
}

type ButtonType =
  | {
      type: 'businessLink'
      text: string
    }
  | {
      type: 'appStore' | 'googlePlay'
    }

export type BeforeRegButton = ButtonType & {link: string; goal: string}

export function ModalCard({title, icon, options, buttons}: BeforeRegModalCard) {
  const {reachGoal} = useContext(Context)

  return (
    <>
      <div className={classnames(styles.card)}>
        <div className={classnames(styles.titleContainer)}>
          <div className={classnames(styles.imageContainer)}>{icon}</div>
          <Text tag="h2" kind="titleBold" mobile={{kind: 'labelBold'}}>
            {title}
          </Text>
        </div>
        <ul className={classnames(styles.list)}>
          {options.map(option => (
            <li key={option} className={classnames(styles.listItem)}>
              <Text tag="span" color="red" kind="label">{`—  `}</Text>
              <Text tag="span" kind="label" mobile={{kind: 'body'}}>
                {option}
              </Text>
            </li>
          ))}
        </ul>
        <div className={classnames(styles.buttonContainer)}>
          {buttons.map(button =>
            button.type === 'businessLink' ? (
              <LinkButton
                key={button.link}
                href={button.link}
                icon="arrow"
                iconColor="white"
                size="xl"
                variant="primary"
                stretchToFillContainer
                isIconAbsolutePos
                iconSize="l"
                className={classnames(styles.buttonLink)}
                onClick={() => {
                  button.goal && reachGoal?.(button.goal)
                }}
              >
                <Text tag="a" color="whiteTotal" kind="label" mobile={{kind: 'body'}}>
                  {button.text}
                </Text>
              </LinkButton>
            ) : (
              <AppButton
                key={button.type === 'appStore' ? 'appStore' : 'googlePlay'}
                icons={[button.type === 'appStore' ? 'appStore' : 'googlePlay']}
                onClick={() => {
                  button.goal && reachGoal?.(button.goal)
                }}
                href={button.link}
                stretchToFillContainer
              />
            ),
          )}
        </div>
      </div>
    </>
  )
}
